import { Button, Pagination } from "antd";
import React from "react";
import { ArrowLeftOutlined, ArrowRightOutlined } from "@ant-design/icons";
function CustomPagination({
  onPageChange,
  pageSize = 15,
  totalItems = 40,
  currentPage,
  setCurrentPage,
}) {
  const previousIsDisabled = currentPage === 1;
  const nextIsDisabled = currentPage * pageSize >= totalItems;

  const onNext = () => {
    const nextPage = currentPage + 1;
    const nextOffset = nextPage * pageSize - pageSize;
    onPageChange(nextPage, nextOffset);
    setCurrentPage((prev) => nextPage);
  };
  const onPrevious = () => {
    const prevPage = currentPage - 1;
    const prevOffset = prevPage * pageSize - pageSize;
    onPageChange(prevPage, prevOffset);
    setCurrentPage((prev) => prevPage);
  };
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginTop: 20,
      }}
    >
      {!previousIsDisabled ? (
        <Button onClick={onPrevious} disabled={previousIsDisabled}>
          <ArrowLeftOutlined /> Previous
        </Button>
      ) : (
        <div style={{ width: 100 }} />
      )}
      <Pagination
        current={currentPage}
        total={totalItems}
        pageSize={pageSize}
        onChange={(page) => {
          const offset = page * pageSize - pageSize;
          onPageChange(page, offset);
          setCurrentPage((prev) => page);
        }}
        showSizeChanger={false}
      />
      <Button onClick={onNext} disabled={nextIsDisabled}>
        Next <ArrowRightOutlined />
      </Button>
    </div>
  );
}

export default CustomPagination;
